<template>
<div>
    <div class="row d-flex align-items-center justify-content-start">
        <div class="col-10">
            <Button @click="$router.push('/group')" size="small" type="outline" color="grey">
                <ArrowDropdown :rotate="90" /> Voltar
            </Button>
        </div>
        <div class="col-10 my-4">
            <h3 class="c-ndarkthree">
                <span class="bold">Novo grupo econômico</span> | Dados do grupo
            </h3>
        </div>
        <div class="col-10">
            <el-steps direction="vertical" :active="activeStep" finish-status="success">
                <el-step title="Inserir dados do grupo">
                    <div class="col-12 mt-4" slot="description" v-if="activeStep === 0">
                        <el-form :model="group" ref="group">
                            <div class="row">
                                <div class="col-6">
                                    <el-form-item prop="name">
                                        <InputText v-model="group.name" label="Nome do grupo" placeholder="Nome do grupo"/>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <el-form-item prop="city">
                                        <InputText v-model="group.city" label="Cidade" placeholder="Cidade"/>
                                    </el-form-item>
                                </div>
                                <div class="col-2">
                                    <el-form-item prop="state">
                                        <InputText v-model="group.state" label="Estado" placeholder="UF" />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <el-form-item prop="site">
                                        <InputText v-model="group.site" label="Website" placeholder="Website" />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <el-form-item prop="partnerId" v-if="!USER_TYPE_MIXIN.isBackOffice">
                                        <label for="">Parceiro vinculado</label>
                                        <el-select v-model="group.partnerId" placeholder="Selecione">
                                            <el-option
                                                v-for="partner in partners"
                                                :key="partner.name"
                                                :label="partner.name | formatName"
                                                :value="partner.id"
                                            >
                                            {{ partner.name | formatName }}
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row mb-3 pb-2">
                                <div class="col-6 mt-4">
                                    <p class="c-nadarkfour bold mb-2">
                                        Logo do sacado
                                    </p>
                                    <!-- <Upload v-model="fileListLogo" :multiple="false" @change="handleChange($event, true)"/> -->
                                    <UploadGroup @change="handleLogoChange"/>
                                </div>
                            </div>
                            <div class="row mb-4 pb-2" v-if="!USER_TYPE_MIXIN.isBackOffice">
                                <div class="col-6">
                                    <p class="c-nadarkfour bold mb-2">
                                        Sobre o sacado
                                    </p>
                                    <!-- <Upload v-model="fileListAbout" :multiple="false" @change="handleChange($event, false)"/> -->
                                    <UploadGroup :about="true" @change="handleAboutChange"/>
                                </div>
                            </div>
                        </el-form>
                        <Button :color="getPrimaryColor" :disabled="!group.name.length" @click="nextStep">Continuar</Button>
                    </div>
                </el-step>
                <!-- <el-step title="Selecionar parceiros" class="mt-4">
                    <div class="col-12 mt-4" slot="description" v-if="activeStep === 1">
                        <el-form :model="group" ref="group">
                            <div>
                                <el-form-item prop="partnerId">
                                    <div class="d-flex flex-column">
                                        <el-radio :class="getPrimaryColor" v-for="partner in partners"  v-model="group.partnerId" :label="partner.id" :key="partner.name" class="`${getPrimaryColor} partner-item p-4`">
                                            {{ partner.logo }}
                                            {{ partner.name | formatName}}
                                        </el-radio>
                                    </div>
                                </el-form-item>
                            </div>
                        </el-form>
                        <Button :color="getPrimaryColor" :disabled="!group.name.length" @click="nextStep">Continuar</Button>
                    </div>
                    <Button :color="getPrimaryColor" @click="nextStep">Continuar</Button>
                </el-step> -->
                <el-step :title="!USER_TYPE_MIXIN.isBackOffice ? 'Selecionar compradores' : 'Selecionar sacados'">
                </el-step>
                <el-step :title="!USER_TYPE_MIXIN.isBackOffice ? 'Selecionar fornecedores' : 'Selecionar cedentes'">
                </el-step>
                <el-step title="Configurar regras da operação">
                </el-step>
            </el-steps>
        </div>
    </div>
</div>
</template>

<script>
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import insertEconomicGroup from '@/api/insertEconomicGroup'
import insertEconomicGroupLogo from '@/api/insertEconomicGroupLogo'
import insertEconomicGroupAbout from '@/api/insertEconomicGroupAbout'
import UploadGroup from '@/components/uploads/UploadGroup'
import getCompanyPartners from '@/api/getCompanyPartners'

export default {
    components: {
        ArrowDropdown,
        UploadGroup
    },
    data() {
        return {
            activeStep: 0,
            group: {
                name: '',
                city: '',
                state: '',
                site: '',
                logo: '',
                aboutPhoto: '',
                partnerId: ''
            },
            logo: {
                id: '',
                fileName: '',
                logoFile: ''
            },
            aboutPhoto: {
                id: '',
                fileName: '',
                aboutFile: ''
            },
            partners: [],
        }
    },
    methods: {
        async nextStep() {
            const result = await insertEconomicGroup(this.group)
            if (result.data.ok) {
                let resultLogo = true
                let resultAbout = true
                if (this.logo.logoFile.length) {
                    resultLogo = await insertEconomicGroupLogo(result.data.payload.id, this.logo)
                }
                if (this.aboutPhoto.aboutFile.length) {
                    resultAbout = await insertEconomicGroupAbout(result.data.payload.id, this.aboutPhoto)
                }
                if (resultLogo && resultAbout) {
                    this.$router.push(`/group/${result.data.payload.id}/buyer`)
                } else {
                    console.log('Erro')
                }
            } else {
                console.log('Erro')
            }
        },
        previewFile(file) {
            window.open(`${process.env.VUE_APP_ROOT_API}/${file.path}`)
        },
        handleLogoChange(base64File) {
            this.logo = {
                fileName: base64File.name,
                logoFile: base64File.file
            }
        },
        handleAboutChange(base64File) {
            this.aboutPhoto = {
                fileName: base64File.name,
                aboutFile: base64File.file
            }
        },
    },
    async created() {
        const partners = await getCompanyPartners()
        this.partners = partners
        if (this.USER_TYPE_MIXIN.isBackOffice) this.group.partnerId = '0'
    },
}
</script>

<style lang="scss" scoped>
.partner-item {
    width: 100%;
    // height: 72px;
    border-radius: 6px;
    border: 1px solid #DFE2EB;
    margin: 10px 0px;
}
</style>